import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopOrderProviderInput,
    PopOrderProvider,
    UpdatePopOrderProviderInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopOrderProviderService {
    private amplifyClient = generateClient();

    constructor() {}

    async listPopOrderProviders(): Promise<PopOrderProvider[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopOrderProviders
                })
            ).data.listPopOrderProviders.items;
            if (data) return data as PopOrderProvider[];
        } catch (error) {
            console.error('Error finding PopOrderProvider:', error);
            return null;
        }
    }

    async popOrderProviderByPopOrde(
        orderId: string
    ): Promise<PopOrderProvider[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.popOrderProviderByPopOrder,
                    variables: {
                        orderId
                    }
                })
            ).data.popOrderProviderByPopOrder.items;
            if (data) return data as PopOrderProvider[];
        } catch (error) {
            console.error('Error finding PopOrderProvider:', error);
            return null;
        }
    }
    async popOrderProviderByCreatedAt(
        providerId: string
    ): Promise<PopOrderProvider[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.popOrderProviderByCreatedAt,
                    variables: {
                        providerId
                    }
                })
            ).data.popOrderProviderByCreatedAt.items;
            if (data) return data as PopOrderProvider[];
        } catch (error) {
            console.error('Error finding PopOrderProvider:', error);
            return null;
        }
    }

    async createPopOrderProvider(
        input: CreatePopOrderProviderInput
    ): Promise<PopOrderProvider> {
        return this.createPopOrderVehicle(input);
    }

    async createPopOrderVehicle(
        input: CreatePopOrderProviderInput
    ): Promise<PopOrderProvider> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopOrderProvider,
                    variables: {
                        input
                    }
                })
            ).data.createPopOrderProvider;
            if (date) return date as PopOrderProvider;
        } catch (error) {
            console.error('Error creating PopOrderAuthorizer:', error);
            return null;
        }
    }

    async updatePopOrder(
        input: UpdatePopOrderProviderInput
    ): Promise<PopOrderProvider> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopOrderProvider,
                    variables: {
                        input
                    }
                })
            ).data.updatePopOrderProvider;
            if (date) return date as PopOrderProvider;
        } catch (error) {
            console.error('Error updated PopOrderAuthorizer:', error);
            return null;
        }
    }
}
